var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_3951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3026 19.9876V10.8766H15.3595L15.8182 7.32485H12.3026V5.05756C12.3026 4.02956 12.5869 3.32899 14.0627 3.32899L15.9419 3.32822V0.151387C15.6169 0.109155 14.5014 0.0123291 13.203 0.0123291C10.4917 0.0123291 8.63557 1.66725 8.63557 4.7058V7.32485H5.56934V10.8766H8.63557V19.9876H12.3026Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_3951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9753,
    height: 19.9753,
    fill: "white",
    transform: "translate(0.767578 0.0123291)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbicon);
export default __webpack_public_path__ + "static/media/fbicon.e6abd8edeae500fadac91c002ea6fc30.svg";
export { ForwardRef as ReactComponent };